import { render, staticRenderFns } from "./linkIcon.vue?vue&type=template&id=76a2d498&"
import script from "./linkIcon.vue?vue&type=script&lang=js&"
export * from "./linkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports